<template>
    <loadtem v-if="proloading" :progress="progress" :point="point"></loadtem>
    <ScaleScreen :width="1920" :height="1080" class="scale-wrap" v-else>
        <div class="template">
            <homehead class="head_animation"></homehead>
            <div class="tem-content">
                <div class="left-content">
                    <textTitle3 title="土地概况" class="left_animation_1"></textTitle3>
                    <leftTop class="left_animation_1"></leftTop>
                    <textTitle3 title="农作物生产销售数据" class="left_animation_2"></textTitle3>
                    <leftCent class="left_animation_2"></leftCent>
                    <textTitle3 title="农业认养实时视频" class="left_animation_3"></textTitle3>
                    <leftBottom class="left_animation_3"></leftBottom>
                </div>
                <div class="center-content">
                    <centerTop class="center_animation_1"></centerTop>
                    <centerbg></centerbg>
                    <div class="center-bottom-outer">
                        <textTitle3 title="教育质量情况" class="center-bottom-outer-left center_animation_2"></textTitle3>
                        <centerBottomLeft class="center-bottom-outer-left-b center_animation_2"></centerBottomLeft>
                        <textTitle3 title="居民支配收入情况" class="center-bottom-outer-right center_animation_2"></textTitle3>
                        <centerBottomRight class="center-bottom-outer-right-b center_animation_2"></centerBottomRight>
                    </div>
                </div>
                <div class="right-content">
                    <textTitle3 title="卫生医疗监控" class="right_animation_1"></textTitle3>
                    <rightTop class="right_animation_1"></rightTop>
                    <textTitle3 title="森林草场安防监测" class="right_animation_2"></textTitle3>
                    <rightBottom class="right_animation_2"></rightBottom>
                </div>
            </div>
        </div>
    </ScaleScreen>
</template>

<script>
import homehead from '../../components/template/temhead2.vue'
import ScaleScreen from '../../components/scale-screen/scale-screen.vue'
import centerbg from '../../components/template/centerbg.vue'
import leftTop from "../../components/template/leftT-temp3.vue";
import leftCent from "../../components/template/leftC-temp3.vue";
import leftBottom from "../../components/template/leftB-temp3.vue";
import centerTop from "../../components/template/centerT-temp3.vue";
import centerBottomLeft from "../../components/template/centerB-Left-temp3.vue";
import centerBottomRight from "../../components/template/centerB-Right-temp3.vue";
import rightTop from "../../components/template/rightT-temp3.vue";
import rightBottom from "../../components/template/rightB-temp3.vue";
import textTitle3 from "../../components/template/textTitle-temp3.vue";
import loadtem from '../../components/porloading.vue'
import { preloadResources } from "@/utils/loading";
export default {
    components: {
        ScaleScreen,
        homehead,
        centerbg,
        leftTop,
        leftCent,
        leftBottom,
        centerTop,
        centerBottomLeft,
        centerBottomRight,
        rightTop,
        rightBottom,
        textTitle3,
        loadtem,
    },
    data() {
        return {
            titleArr: ['土地概况', '农作物生产销售数据', '农业认养实时视频', '教育质量情况', '居民支配收入情况', '卫生医疗监控', '森林草场安防监测'],
            proloading: true,
            point: '.',
            time1: null,
            progress: 0
        };
    },
    async created() {
        const resourceList = [
            require("@/assets/template3/bar-bg.png"),
            require("@/assets/template3/btimg.png"),
            require("@/assets/template3/center-bg.png"),
            require("@/assets/template3/cent-top.png"),
            require("@/assets/template3/homebg.png"),
            require("@/assets/template3/header.png"),
            require("@/assets/template3/map-bg.png"),
            require("@/assets/template3/temporary1.png"),
            require("@/assets/template3/temporary2.png"),
            require("@/assets/template3/temporary3.png"),
            require("@/assets/template3/temporary4.png"),
            require("@/assets/template3/title.png"),
            require("@/assets/template3/title-text-bg.png"),

            // require("@/assets/template3/header-left.png"),
            // require("@/assets/template3/header-right.png"),
            // require("@/assets/template3/img-bg.png"),
            // require("@/assets/template3/left-icon.png"),
            // require("@/assets/template3/right-icon.png"),
            // require("@/assets/template3/fangkuai.png"),
            // require("@/assets/template3/sanjiao.png"),

        ];
        if (!this.time1) {
            this.time1 = setInterval(() => {
                this.addpoint()
            }, 600)
        }
        this.addpoint()
        await preloadResources(resourceList, this.progressCallback);
        clearInterval(this.time1)
        this.time1 = null
        this.proloading = false
    },
    methods: {
        progressCallback(progress) {
            this.progress = progress * 100
        },
        addpoint() {
            if (this.point !== '...') {
                this.point += '.'
            } else {
                this.point = ''
            }
        }
    }
}
</script>

<style scoped lang="scss">
.template {
    width: 100%;
    height: 100%;
    display: block;
    position: relative;
    z-index: 1;
    background: url('../../assets/template3/homebg.png') no-repeat;
    background-size: 100% 100%;

    .tem-content {
        margin: -30px auto;
        height: 890px;
        width: 100%;

        display: flex;
        pointer-events: none;
    }

    .left-content,
    .right-content {
        width: 475px;
        position: relative;
        z-index: 401;
        pointer-events: auto;
    }

    .center-content {
        width: 970px;
        position: relative;
        z-index: 401;
        pointer-events: auto;
        padding: 0 50px;
        box-sizing: border-box;

        .center-bottom-outer {
            width: 870;
            height: 120px;
            justify-content: space-between;
            margin: 632px auto;
            position: relative;

            z-index: 402;

            .center-bottom-outer-left {
                position: absolute;
                top: 0;
                left: 0;

                &-b {
                    position: absolute;
                    left: 0;
                    top: 37.5px;
                }
            }

            .center-bottom-outer-right {
                position: absolute;
                top: 0;
                right: 0;

                &-b {
                    position: absolute;
                    right: 0;
                    top: 37.5px;
                }
            }
        }
    }

    .left-content {
        padding: 0 0 0 40px;
    }

    .right-content {
        padding: 0 40px 0 0;
        box-sizing: border-box;
    }

    .center-content {
        width: 970px;
        // background: #ffffff;
        position: relative;
        z-index: 401;
    }
}
</style>